const styles = {
  containerFill: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
  },
  dataGridFill: {
    flex: 1,
    minHeight: 0,
    '& .MuiDataGrid-main': {
      minHeight: 0,
    },
  },
  loader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 240,
  },
  loaderFill: {
    flex: 1,
    minHeight: 0,
  },
  actionCell: {
    '&.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
  activeFilters: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
  },
  activeFiltersContainer: {
    flexShrink: 0,
    mb: 2,
  },
  activeFiltersSpacer: {
    display: { xs: 'none', lg: 'block' },
  },
  filterBar: {
    width: '100%',
  },
  filterSubmit: {
    boxShadow: 'none',
    width: { xs: '100%', sm: 'auto' },
    '&:hover': {
      boxShadow: 'none',
    },
  },
  gridPagination: {
    flexShrink: 0,
    '& .MuiTablePagination-displayedRows': {
      display: 'none',
    },
  },
  pagination: {
    '& .MuiPaginationItem-root': {
      minWidth: 32,
    },
  },
  tableFill: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
  },
  toolbar: {
    flexShrink: 0,
    mb: 2,
  },
  toolbarActions: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
  },
};

export default styles;
